if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();

        this.mqlDesktop = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');

        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');

        this.mouseEnterTriggered = false;

        // Close button
        if (this.closeButton) {
          this.closeButton.addEventListener('click', (e) => this.closePopover(e));
        }

        // Desktop hover
        if (this.infoButtonDesktop && this.mqlTablet.matches && this.popoverInfo) {
          this.infoButtonDesktop.addEventListener('mouseenter', (e) => this.openPopover(e));
          this.infoButtonDesktop.addEventListener('mouseleave', (e) => this.closePopover(e));
          this.popoverInfo.addEventListener('mouseleave', (e) => this.closePopover(e));
        }

        // Desktop click
        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', (e) => this.togglePopover(e));
          this.infoButtonDesktop.addEventListener('focusout', (e) => this.closePopover(e));
        }

        // Mobile click
        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', (e) => this.togglePopover(e));
        }

        // --- Removed all "+" / "-" button logic ---
        // No quantity buttons, customers type manually
      }

      togglePopover(event) {
        event.preventDefault();

        const button = (this.infoButtonDesktop && this.mqlDesktop.matches) ? this.infoButtonDesktop : this.infoButtonMobile;
        if (!button || !this.popoverInfo) return;

        const isOpen = button.getAttribute('aria-expanded') === 'true';
        const shouldOpen = event.type === 'click' ? !isOpen : true;

        button.setAttribute('aria-expanded', shouldOpen);
        this.popoverInfo.toggleAttribute('hidden', !shouldOpen);
        button.classList.toggle('quantity-popover__info-button--open', shouldOpen);

        if (shouldOpen) {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') this.closePopover(e);
          });
        }
      }

      openPopover(event) {
        if (!this.mouseEnterTriggered) {
          this.mouseEnterTriggered = true;
          this.togglePopover(event);
        }
      }

      closePopover(event) {
        if (!this.popoverInfo || !this.infoButtonDesktop) return;

        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        if (!isButtonChild && !isPopoverChild) {
          this.infoButtonDesktop.setAttribute('aria-expanded', 'false');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
          this.mouseEnterTriggered = false;
        }
      }
    }
  );
}